import { UserService } from './../../../../../../shared/services/user.service';
import {ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AuthService, UserType } from '../../../../../../modules/auth';
import {SessionService} from "../../../../../../shared/services/session/session.service";
import {SessionQuery} from "../../../../../../shared/services/session/session.query";
import {SessionStore} from "../../../../../../shared/services/session/session.store";

@Component({
  selector: 'app-user-inner',
  templateUrl: './user-inner.component.html',
})
export class UserInnerComponent implements OnInit, OnDestroy {
  @HostBinding('class')
  class = `menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-auto`;
  @HostBinding('attr.data-kt-menu') dataKtMenu = 'true';

  user: UserType | null;
  private unsubscribe: Subscription[] = [];
  profileImage: string | null;

  constructor(
    private sessionService: SessionService,
    private auth: AuthService,
    private cdRef: ChangeDetectorRef,
    public sessionQuery: SessionQuery,
    private sessionStore: SessionStore
  ) {}

  ngOnInit(): void {
    this.user = this.sessionQuery.getValue().user;
    this.profileImage = this.sessionQuery.getValue().profileImage;
    this.sessionStore.currentProfileImage.subscribe(res => {
      this.profileImage = this.sessionQuery.getValue().profileImage;
    })
    // this.sessionService.currentProfileImageSubject.subscribe({
    //   next: (res) => {
    //     console.log(res);
    //     this.profileImage = res;
    //   }
    // })
  }

  logout() {
    this.auth.logout();
    this.cdRef.markForCheck();
  }


  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
